"use client";

import React from "react";
import { ShieldCheck, Truck, Users, CircleDollarSign } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Управление заказами",
  description: "Оптимизируйте обработку и отслеживание заказов в режиме реального времени для максимальной эффективности.",
  icon: ShieldCheck
}, {
  title: "Центр документации",
  description: "Централизованное хранилище и управление всеми важными документами и контрактами в одном месте.",
  icon: Truck
}, {
  title: "Аналитика показателей",
  description: "Отслеживайте метрики поставщиков и ключевые показатели эффективности для принятия обоснованных решений.",
  icon: Users
}, {
  title: "Финансовый контроль",
  description: "Прозрачный мониторинг платежей и финансовых операций между всеми участниками цепочки поставок.",
  icon: CircleDollarSign
}];
export default function WhyChooseUs() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="244226" id="supplier-portal-features" className="py-16 md:py-24 bg-primary text-foreground-primary">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-5xl font-bold text-white mb-4">
            Возможности портала поставщиков
          </h2>
          <p className="text-primary-light/80 text-lg font-default">
            Инновационные инструменты для прозрачного взаимодействия и эффективного управления вашими бизнес-процессами.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 transition-all duration-700 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className="group transition-all duration-300 hover:shadow-strong hover:-translate-y-1 border-white/10 bg-secondary-dark/40 backdrop-blur-sm">
                <CardHeader className="pb-4">
                  <div className="size-12 rounded-sm bg-accent/20 flex items-center justify-center mb-4 text-accent transition-colors duration-300 group-hover:bg-accent group-hover:text-white">
                    <Icon className="size-6" />
                  </div>
                  <CardTitle className="font-default text-xl text-white">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-primary-light/70 font-default">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}